<template>
  <div class="jia_footer">
    <div class="jia_foot_info">
      <div class="jia_foot_con">
        <ul class="jia_foot_link">
          <li v-for="item of links" :key="item.text">
            <a
              :href="item.href"
              rel="nofollow"
              target="_blank"
              v-html="item.text"
            ></a>
          </li>
        </ul>
      </div>
      <p>上海多维度网络科技股份有限公司 © 2013-2016</p>
      <p>
        沪ICP备12029856号-1
        <br />
        <img src="../../assets/beianbgs.png" alt style="height: 15px" />
        沪公网安备 31010402002142号
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PcFooter',
  data() {
    return {
      links: [
        { href: 'https://www.doweidu.com', text: '关于我们' },
        { href: 'https://www.doweidu.com/dwd.html#contact', text: '联系我们' },
        {
          href: 'https://www.doweidu.com/dwd.html#app-product',
          text: 'APP产品',
        },
        { href: 'https://www.doweidu.com/joinus.html', text: '加入我们' },
      ],
    }
  },
}
</script>
<style lang="less" scoped>
.jia_footer {
  margin-top: 30px;
  padding-bottom: 20px;
  background-color: #fff;
  p {
    line-height: 24px;
    color: #aaa;
    text-align: center;
  }
}
.jia_foot_link {
  padding: 10px 0;
  text-align: center;
  li {
    font-size: larger;
    display: inline-block;
    & a {
      font-family: PingFangSC-Regular;
      margin-left: 15px;
      color: #333333;
      display: inline-block;
      &:hover {
        color: #d00;
      }
    }
    &::after {
      content: '|';
      display: inline-block;
      color: #ddd;
      margin-left: 15px;
    }
    &:last-of-type::after {
      display: none;
    }
  }
}
</style>
